var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 24,
    rx: 2,
    fill: "#353A48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 -4H2V28H34V-4Z",
    fill: "#353A48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7.19184C19.271 6.09945 20.9197 5.44 22.7213 5.44C26.7412 5.44 30 8.72325 30 12.7733C30 16.8234 26.7412 20.1067 22.7213 20.1067C20.9197 20.1067 19.271 19.4472 18 18.3548C16.729 19.4472 15.0803 20.1067 13.2787 20.1067C9.25878 20.1067 6 16.8234 6 12.7733C6 8.72325 9.25878 5.44 13.2787 5.44C15.0803 5.44 16.729 6.09945 18 7.19184Z",
    fill: "#FF5E00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7.19184C16.435 8.53691 15.4426 10.5384 15.4426 12.7733C15.4426 15.0083 16.435 17.0098 18 18.3548C16.729 19.4472 15.0803 20.1067 13.2787 20.1067C9.25878 20.1067 6 16.8234 6 12.7733C6 8.72325 9.25878 5.44 13.2787 5.44C15.0803 5.44 16.729 6.09945 18 7.19184Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18.3548C19.565 17.0098 20.5574 15.0083 20.5574 12.7733C20.5574 10.5384 19.565 8.53691 18 7.19184C19.271 6.09945 20.9197 5.44 22.7213 5.44C26.7412 5.44 30 8.72325 30 12.7733C30 16.8234 26.7412 20.1067 22.7213 20.1067C20.9197 20.1067 19.271 19.4472 18 18.3548Z",
    fill: "#F9A000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.25f60d681f7d8f18a3d331e3e8b087ef.svg";
export { ForwardRef as ReactComponent };